import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';
import s from '../styles/DetailContent.module.css';

const Knowledge43 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='エクシブとは？リゾートトラストのゴルフ会員権との関係を解説' fontWeight={700} />
                <p>
                    エクシブとは、リゾートトラスト株式会社が開発・販売・運営する会員制リゾートホテルブランドです。
                    <br />
                    1987年開業の「エクシブ鳥羽」を皮切りに、現在は全国各地のリゾートエリアに展開しています。
                    <br />
                    リゾートトラストグループ全体の会員数は、2025年3月時点で約20万人にのぼります。
                </p>
                <p>
                    エクシブの客室は「タイムシェアリング・システム」という仕組みで運営されており、1つの客室を14人で共同所有し、年間26泊の利用が保証される会員制になっています。
                    <br />
                    リゾートトラストグループはゴルフ会員権事業も展開しており、ゴルフ会員権を持つことでエクシブを含む系列ホテルを優待利用できる点が、他のゴルフ会員権グループにはない大きな特徴です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権でエクシブを利用する際の条件' fontWeight={700} />
                <p>
                    リゾートトラストグループのゴルフ場の会員になることで、エクシブ・リゾーピア・サンメンバーズ系ホテルに年間2泊することができます。
                    <br />
                    ただし、この特典には以下のような条件がある点にご注意ください。
                </p>
                <Heading3 title='利用条件' />
                <div className={s.h4_link}>・対象者はゴルフ場会員本人及び配偶者に限られる</div>
                <div className={s.h4_link}>・繁忙期（年末年始・お盆・金曜日・土曜日）は利用不可</div>
                <p>
                    なお、エクシブオーナー向けには「RTTGポイントクラブ」という制度もあり、毎月14日・28日にポイント5倍サービスが提供されるなど、独自の特典も用意されています。
                    <br />
                    ※特典内容は変更される場合がありますので、最新情報は公式サイトでご確認ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='リゾートトラストグループのゴルフ場のおすすめは？' fontWeight={700} />
                <p>
                    リゾートトラストグループのゴルフ場一覧は
                    <a href='https://juchi.jp/courses?series_id=60' className={s.link}>
                        こちら
                    </a>
                    よりご確認ください。
                    <br />
                    コースごとの特徴や会員権の相場については、
                    <a href='/knowledge/22'>リゾートトラストグループのゴルフ会員権を解説した記事</a>
                    でも詳しくご紹介しています。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権に関するご相談は住地ゴルフへ' fontWeight={700} />
                <p>
                    エクシブをはじめとするリゾートホテルを優待利用できる点は、リゾートトラストグループのゴルフ会員権ならではの魅力です。
                    <br />
                    <br />
                    具体的な利用条件やコースの特徴、売買状況については、お気軽に弊社にお問合せください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge43;
